import React from 'react';

export const AdminPanelAgendamentosTab = ({ contactSubmissions, handleDeleteContact }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm p-6" data-testid="admin-panel-agendamentos-tab">
      <div className="flex items-center justify-between gap-4 mb-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Envios do Questionário</h2>
          <p className="text-sm text-gray-500">Esses são os registros salvos em `contacts`, incluindo os testes enviados.</p>
        </div>
        <span className="px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-sm font-medium" data-testid="admin-panel-contacts-count">
          {contactSubmissions.length} envio(s)
        </span>
      </div>

      {contactSubmissions.length === 0 ? (
        <p className="text-gray-500" data-testid="admin-panel-contacts-empty">Nenhum envio encontrado.</p>
      ) : (
        <div className="space-y-4" data-testid="admin-panel-contacts-list">
          {contactSubmissions.map((contact) => (
            <div key={contact.id} className="border border-gray-200 rounded-xl p-4 flex flex-col md:flex-row md:items-start md:justify-between gap-4" data-testid={`admin-panel-contact-card-${contact.id}`}>
              <div className="min-w-0">
                <p className="font-semibold text-gray-900">{contact.name}</p>
                <p className="text-sm text-gray-600 break-all">{contact.email}</p>
                {contact.phone && <p className="text-sm text-gray-500">{contact.phone}</p>}
                <p className="text-xs text-gray-400 mt-2">{new Date(contact.timestamp).toLocaleString('pt-BR')}</p>
                <p className="text-sm text-gray-700 mt-3 whitespace-pre-wrap break-words">{contact.message}</p>
                <p className="text-xs text-blue-600 mt-3">{contact.uploaded_files?.length || 0} arquivo(s) anexado(s)</p>
              </div>

              <button
                type="button"
                onClick={() => handleDeleteContact(contact)}
                className="px-4 py-2 rounded-lg bg-red-50 text-red-700 hover:bg-red-100 transition shrink-0"
                data-testid={`admin-panel-delete-contact-button-${contact.id}`}
              >
                Excluir envio
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
